import type { components } from '@fluencelabs/vodopad-admin-api'

type IntentStatus = components['schemas']['IntentStatus']
type ParkReason = components['schemas']['ParkReason']
type PaymentMethodKind = components['schemas']['PaymentMethodKind']

export const PAYMENT_INTENT_STATUSES: IntentStatus[] = [
  'open',
  'needs_review',
  'canceled',
  'expired',
  'resolved',
]

// Only `needs_review` is actionable (resolve-review); the rest are read-only.
export const INTENT_STATUS_COLORS: Record<string, string> = {
  open: 'processing',
  needs_review: 'warning',
  resolved: 'success',
  canceled: 'default',
  expired: 'default',
}

export const PARK_REASON_LABELS: Record<ParkReason, string> = {
  non_usd_paid_currency: 'Non-USD paid currency',
  non_usd_intent_currency: 'Non-USD intent currency',
  non_positive_claim: 'Non-positive claim',
  amount_over_cap: 'Amount over per-entry cap',
  partial_after_terminal: 'Partial after terminal',
  provider_requires_review: 'Provider requires review',
  downward_correction: 'Downward correction',
  late_deposit_prior_settlement: 'Late deposit, prior settlement',
  late_deposit_ambiguous_tx: 'Late deposit, ambiguous tx',
  late_deposit_tx_drift: 'Late deposit, tx drift',
  repeat_deposit: 'Repeat deposit',
}

export const PAYMENT_METHOD_KINDS: PaymentMethodKind[] = ['crypto', 'fiat']
